function formatNumber(n) {
  n = n.toString();

  return n[1] ? n : "0" + n;
}

/** 

* 时间戳转化为年 月 日 时 分 秒 

* number: 传入时间戳 

* format：返回格式，支持自定义，但参数必须与formateArr里保持一致 

*/

function formatTime(number, format) {
  var formateArr = ["Y", "M", "D", "h", "m", "s"];

  var returnArr = [];

  var date = new Date(number * 1000);

  returnArr.push(date.getFullYear());

  returnArr.push(formatNumber(date.getMonth() + 1));

  returnArr.push(formatNumber(date.getDate()));

  returnArr.push(formatNumber(date.getHours()));

  returnArr.push(formatNumber(date.getMinutes()));

  returnArr.push(formatNumber(date.getSeconds()));

  for (var i in returnArr) {
    format = format.replace(formateArr[i], returnArr[i]);
  }

  return format;
}

/**
 * 获取10位时间戳
 */
function timest() {
  var tmp = Date.parse(new Date()).toString();
  tmp = tmp.substr(0, 10);
  return tmp;
}

/**
 * 获取视频路径别名
 */
function get_vkname(filename) {
  var index1 = filename.lastIndexOf("/");
  index1 = index1 + 1;
  var index2 = filename.lastIndexOf(".");
  var vkname = filename.substring(index1, index2);
  return vkname;
}

/**
 * 10位时间转12位
 */
function toDate(number) {
  var n = number * 1000;
  var date = new Date(n);
  var Y = date.getFullYear() + "-";
  var M =
    (date.getMonth() + 1 < 10 ?
      "0" + (date.getMonth() + 1) :
      date.getMonth() + 1) + "-";
  var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  return Y + M + D;
}

/**
 * 数据以万为单位
 */
function manyNumber(num) {
  var n = (num / 10000).toFixed(1) + "万";
  return n;
}
/**
 * 存储localStorage
 */
var setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== "string") {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
var getStore = name => {
  if (!name) return;
  return window.localStorage.getItem(name);
};

/**
 * 删除localStorage
 */
var removeStore = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
};
/**
 * 中国标准时间转换成2012-5-12
 */
var getTime = value => {
  var d = new Date(value);
  var time = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
  return time;
};


//转换时间格式
function formatFun(time, format) {
  var t = new Date(time);
  var tf = function(i) {
    return (i < 10 ? "0" : "") + i;
  };
  return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function(a) {
    switch (a) {
      case "yyyy":
        return tf(t.getFullYear());
        break;
      case "MM":
        return tf(t.getMonth() + 1);
        break;
      case "mm":
        return tf(t.getMinutes());
        break;
      case "dd":
        return tf(t.getDate());
        break;
      case "HH":
        return tf(t.getHours());
        break;
      case "ss":
        return tf(t.getSeconds());
        break;
    }
  });
};

/*
*字符串转16进制
*/

function strToHexCharCode(str) {
　　if(str === "")
　　　　return "";
　　var hexCharCode = [];
　　hexCharCode.push("0x"); 
　　for(var i = 0; i < str.length; i++) {
      var aa = (str.charCodeAt(i)).toString(16)
      if(str.charCodeAt(i) <= 15){
        aa = '0'+ aa
        hexCharCode.push(aa)
      }else{
        hexCharCode.push(aa);
      }
　　}
　　return hexCharCode.join("");
};

/*
*16进制转字符串
*/

function hexCharCodeToStr(hexCharCodeStr) {
　　var trimedStr = hexCharCodeStr.trim();
　　var rawStr = 
　　trimedStr.substr(0,2).toLowerCase() === "0x"
　　? 
　　trimedStr.substr(2) 
　　: 
　　trimedStr;
　　var len = rawStr.length;
　　if(len % 2 !== 0) {
　　　　return "";
　　}
　　var curCharCode;
　　var resultStr = [];
　　for(var i = 0; i < len;i = i + 2) {
　　　　curCharCode = parseInt(rawStr.substr(i, 2), 16); // ASCII Code Value
　　　　resultStr.push(String.fromCharCode(curCharCode));
　　}
　　return resultStr.join("");
}

/*
*2进制转16进制
*/

function bin_to_hex(str) {
  var hex_array = [{key:0,val:"0000"},{key:1,val:"0001"},{key:2,val:"0010"},{key:3,val:"0011"},{key:4,val:"0100"},{key:5,val:"0101"},{key:6,val:"0110"},{key:7,val:"0111"},
      {key:8,val:"1000"},{key:9,val:"1001"},{key:'a',val:"1010"},{key:'b',val:"1011"},{key:'c',val:"1100"},{key:'d',val:"1101"},{key:'e',val:"1110"},{key:'f',val:"1111"}]
  var value = ''
  var list=[]
  if(str.length%4!==0){
    var a = "0000"
    var b=a.substring(0,4-str.length%4)
    str = b.concat(str)
  }
  while (str.length > 4) {
    list.push(str.substring(0, 4))
    str = str.substring(4);
  }
  list.push(str)
  for(var i=0;i<list.length;i++){
      for(var j=0;j<hex_array.length;j++){
          if(list[i]==hex_array[j].val){
              value = value.concat(hex_array[j].key)
              break
          }
      }
  }
  return value
}

/*
*16进制转2进制
*/

function hex_to_bin(str) {
  var hex_array = [{key:0,val:"0000"},{key:1,val:"0001"},{key:2,val:"0010"},{key:3,val:"0011"},{key:4,val:"0100"},{key:5,val:"0101"},{key:6,val:"0110"},{key:7,val:"0111"},
      {key:8,val:"1000"},{key:9,val:"1001"},{key:'a',val:"1010"},{key:'b',val:"1011"},{key:'c',val:"1100"},{key:'d',val:"1101"},{key:'e',val:"1110"},{key:'f',val:"1111"}]

  var value=""
  for(var i=0;i<str.length;i++){
      for(var j=0;j<hex_array.length;j++){
          if(str.charAt(i)== hex_array[j].key){
              value = value.concat(hex_array[j].val)
              break
          }
      }
  }
  return value
}

/*
*16进制转10进制
*/
function hex_to_ten(str) {
  return (parseInt(str, 16)).toString()
}

/*
*异或运算
*/

function xor(a ,b){
  var A = a
  var B = b
  var o = "00000000000000000000000000000000000"
  if(A.toString().length > B.toString().length){
      var c = A.toString().length - B.toString().length
      B = o.substr(0,c).concat(B)
  }else if(A.toString().length < B.toString().length){
      var c = B.toString().length - A.toString().length
      A = o.substr(0,c).concat(A)
  }
  var xorNum = ""
  for(var i=0;i<A.toString().length;i++){
      if(A.toString()[i]==B.toString()[i]){
          var q="0"
          xorNum = xorNum.concat(q)
      }else{
          var p="1"
          xorNum = xorNum.concat(p)
      }
  }
  return xorNum
}

/*
*uint8array 转字符串
*/
function Uint8ArrayToString(fileData){
  var dataString = "";
  for (var i = 0; i < fileData.length; i++) {
    dataString += String.fromCharCode(fileData[i]);
  }
  return dataString
}

/*
*字符串转uint8array 
*/
function stringToUint8Array(str){
  var arr = [];
  for (var i = 0, j = str.length; i < j; ++i) {
    arr.push(str.charCodeAt(i));
  }
 
  var tmpUint8Array = new Uint8Array(arr);
  return tmpUint8Array
}

/*
*处理mqtt传过来的数据(计算bcc)
*/
function checkData(data){
  var str = data
  //把截取到的数据按两个为长度转成数组
  var strArr = [];
  var n = 2;
  for (var i = 0, l = str.length; i < l/n; i++) {
    var a = str.slice(n*i, n*(i+1));
    a = hex_to_bin(a);//把数组的每个元素转成2进制数据
    strArr.push(a);
  }
  //再把数据元素进行异或运算
  var num = 0
  for(var i = 0; i<strArr.length;i++){
    num = xor(num,strArr[i])
    var a = bin_to_hex(num)
  }
  
  var strArr2 = ''
  for(var i in num){
    if(num[i] == 1){
      strArr2+=0
    }else{
      strArr2+=1
    }
  }
  num = bin_to_hex(strArr2)//最后转成16进制显示
  // console.log('bcc',num)
  return num
}


/*
*16进制转ascii码
*/
function hexCharCodeToAscii(hexCharCodeStr) {
  var trimedStr = hexCharCodeStr.trim();
  var rawStr = trimedStr.substr(0, 2).toLowerCase() === "0x" ? trimedStr.substr(2) : trimedStr;
  var len = rawStr.length;
  if (len % 2 !== 0) {
    alert("存在非法字符!");
    return "";
  }
  var curCharCode;
  var resultStr = [];
  for (var i = 0; i < len; i = i + 2) {
    curCharCode = parseInt(rawStr.substr(i, 2), 16);
    resultStr.push(String.fromCharCode(curCharCode));
  }
  return resultStr.join("");
}

export {
  // formatTime,
  // timest,
  // get_vkname,
  // toDate,
  // manyNumber,
  // setStore,
  // getStore,
  // removeStore,
  // getTime,
  // formatFun,
  strToHexCharCode,
  hexCharCodeToStr,
  bin_to_hex,
  Uint8ArrayToString,
  stringToUint8Array,
  hex_to_bin,
  hex_to_ten,
  xor,
  checkData,
  hexCharCodeToAscii
};


//////////////////
// WEBPACK FOOTER
// ./static/js/utils/util.js
// module id = null
// module chunks = 